
import ReactDOM from 'react-dom/client';
import { useEffect, useState } from "react";
import { AppWrapper,} from "../components/helpers";
import app from "../components/app";
import config from "../config";



const ManageUser = function({title, data, close, callback}) {
   const [item, setItem] = useState(data?data:app.defaultData("userKeys"));

   const save = function(){
    if(item["name"] === "") {
      alert("Enter Name!");
      return false;
    }
    if(item["email"] === "") {
      alert("Enter Email!");
      return false;
    }
    if(item["phone"] === "") {
      alert("Enter Phone!");
      return false;
    }
    app.fetchUsers({
      ...item,
      "method":item.id?"update":"insert"
    }).then(function(response){
      console.log(response);
      alert("User information successfully saved and updated!");
      callback(item);
    })
   }
   const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    if(id === "status") {
      setItem({
        ...item,
        status: e.target.getAttribute("data-value") === "1"?1:0,
      });
    }
    else {
      setItem({
        ...item,
        [id]: type === 'checkbox' ? checked : value,
      });
    }
  };
  console.log(item);
  return <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="addPageModalLabel">{title}</h5>
        <button type="button" className="btn-close" onClick={() => close()} />
      </div>
      <div className="modal-body">

          {/* Basic Info */}
          {
              config.userKeys.map(function(v){
                let input = <input type="text" id={v.key} className="form-control" value={item[v.key]} onChange={handleChange} placeholder={v.placeholder} />
                if(v.type === "textarea") {
                  input = <textarea className="form-control" id={v.key} placeholder={v.placeholder.toString()} value={item[v.key]} onChange={handleChange} />
                }
                if(v.type === "password") {
                  input = <input type="password" id={v.key} className="form-control" value={item[v.key]} onChange={handleChange} placeholder={v.placeholder} />
                }
                if(v.type === "select") {
                  input = <select className="form-control" id={v.key} value={item[v.key]} onChange={handleChange}>
                    {
                      v.options.map(function(val){
                        return  <option value={val.value}>{val.text}</option>
                      })
                    }
                   
                  </select>
                }
                if(v.type === "tabs") {
                  input =  <div className="btn-group">
                    {
                      v.options.map(function(val){
                        let active = "";
                        console.log(item[v.key]);
                        if(val.value === item[v.key]) {
                          active = "active";
                        }
                        return <button type="button" id={v.key} onClick={handleChange} data-value={val.value} className={`btn btn-outline-primary ${active}`}>{val.text}</button>
                      })
                    }
                  </div>
                }
               
                return  <div className={`mb-3 ${v.type === "textarea"?"":"d-flex"} ${v.type === "hidden"?"d-none":""}`} key={v.key}>
                  <label className="form-label w-25">{v.text}</label>
                  <div className={`${v.type === "textarea"?"w-100":"w-75"}`}>{input}</div>
                </div>
              })
            }
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={() => close()}>Cancel</button>
        <button type="button" className="btn btn-primary" onClick={save}>Save</button>
      </div>
    </div>
  </div>
}


export default function Users() {
    const [data, setData] = useState([]);
    
    useEffect(() => {
      app.fetchUsers({
        "method":"list"
      }).then(function(response){
        if(response.success) {
          if(response.data.users) {
            setData(response.data.users);
          }
        }
      }); 
    }, []);

    const deleteItem = function(index) {
        if(window.confirm("do you really want to delete this Page")) {
            app.fetchUsers({
                "method":"delete",
                "id":data[index].id
            }).then(function(){
                setData(data.filter(function(v, i){
                    if(i === index) {
                        return false;
                    }
                    return true;
                }))
            })
        }
    }
    
    
    

    const addUser = function(index) {
        const div = document.createElement("div");
        
        div.setAttribute("class", "modal fade show d-block");
        div.setAttribute("style", `background:rgba(0, 0 ,0 ,0.5)`);

        document.body.appendChild(div);
        const divPopup = ReactDOM.createRoot(div);
        divPopup.render(<ManageUser data={index === undefined?null:data[index]} title={index === undefined?"Add User":"Update User"} close={function(){
          div.remove()
        }} callback={function(item){
          setData(data.map(function(v, i){
            if(i === index) {
              return item;
            }
            return v;
          }))
          div.remove();
        }} />, div);
    }

    

   
    return <AppWrapper>
     
<div className="container">

  
  <h3 className="mb-4">Modules <button className="btn btn-success float-end" onClick={() => addUser()}>+ Add Module</button></h3>


  {
    data.map(function(v, i){
      return  <div className="border border-1 rounded-3 p-3 my-2 w-100 d-flex">
        <div className='w-100 d-flex align-items-center'>
          
          <span className="fw-bold">{v.name} ({v.email})</span><span className='ms-2'>{v.phone}</span> 
          <span className={`ms-2 badge ${v.status?"bg-success":"bg-danger"}`}>{v.status?"Active":"Inactive"}</span>
          <span className={`ms-2 badge bg-secondary`}>{v.role}</span>

        </div>
        <div className='m-auto d-inline-flex'>
          <button className="btn btn-sm btn-outline-warning me-1" onClick={() => addUser(i)}>Edit</button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => deleteItem(i)}>Delete</button>
        </div>
      </div>
    })
     
  }

  
  

  

</div>



    </AppWrapper>
}